import { render, staticRenderFns } from "./volume-tsha.vue?vue&type=template&id=066c7a4c&"
import script from "./volume-tsha.vue?vue&type=script&lang=js&"
export * from "./volume-tsha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports